@import "../../../common/_base";

@include box-sizing();

:host {
  display: block;
}
.title {
  margin: 0;
  font: inherit;
}
.list {
  margin: 0;
  padding: 0;
}
